import * as Api from '@ViewModels';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IPhoneCallOutcomeGroup } from '../../aida/viewModels/phonecall';

const BASE_QUERY_KEY = 'aida/outcomes';

export const phoneCallOutcomesQueryOptions = (userSession: Api.UserSessionContext) =>
	queryOptions({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IPhoneCallOutcomeGroup[]>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: BASE_QUERY_KEY }),
				'POST',
				[]
			),
		queryKey: [BASE_QUERY_KEY, userSession.account?.id],
		staleTime: Infinity,
	});

/** Outcome colors keyed by label, the value a logged interaction's outcome carries as its `name`. */
export function usePhoneCallOutcomeColorsQuery() {
	const userSession = useUserSession();

	return useQuery({
		...phoneCallOutcomesQueryOptions(userSession),
		select: groups => {
			const colors = new Map<string, string>();
			for (const outcome of (groups ?? []).flatMap(group => group.children ?? [])) {
				if (outcome.label && outcome.hexColor) {
					colors.set(outcome.label, outcome.hexColor);
				}
			}
			return colors;
		},
		meta: {
			errorLogging: { category: 'PhoneCall', action: 'PhoneCallOutcomeColorsQuery-Error' },
		},
	});
}
